import React from "react";
import { connect } from "react-redux";
import {
  PROVIDER_ROOM_PROCEDURE_TYPE,
  PROVIDER_ROOM_PROCEDURE_VERSION,
} from "../../../api/queries/useProviderRoomProceduresQuery";
import { useProcedures } from "../hooks/useProcedures";
import { TabCosmetic } from "./components/TabCosmetic";
import { TabHealth } from "./components/TabHealth";
import { Layout } from "../components/Layout/Layout";
import { useApiClinics } from "../../Event/hooks/useApiClinics";
import { providerRoom } from "../../../store/providerRoom";

function TabSignedByMd({ history, activeTab }) {
  const historyData = history?.location?.state;
  const chartAuditUserId = historyData?.chartUserId?.toString();
  const {
    procedures,
    fetchNextProcedures,
    proceduresStatus,
    proceduresSearchTerm,
    proceduresType,
    selectClinic,
  } = useProcedures({
    version: PROVIDER_ROOM_PROCEDURE_VERSION.signedByMd,
    clinicID: historyData?.clinic_id,
    providerUserId: chartAuditUserId,
    activeProcedureTab: activeTab,
  });

  const { clinics: availableClinicsList } = useApiClinics();

  const tabByType = {
    [PROVIDER_ROOM_PROCEDURE_TYPE.cosmetic]: (
      <TabCosmetic
        isVisible={proceduresStatus.isVisible}
        onChangeTab={proceduresType.onChange}
        procedures={procedures}
        availableClinicsList={availableClinicsList}
        onChangeClinic={selectClinic.onChange}
        clinicId={selectClinic.value}
        showHideActionButton={Boolean(historyData?.isFromChartAuditReport)}
        providerUserId={chartAuditUserId}
      />
    ),
    [PROVIDER_ROOM_PROCEDURE_TYPE.health]: (
      <TabHealth
        isVisible={proceduresStatus.isVisible}
        onChangeTab={proceduresType.onChange}
        procedures={procedures}
        availableClinicsList={availableClinicsList}
        onChangeClinic={selectClinic.onChange}
        clinicId={selectClinic.value}
        showHideActionButton={Boolean(historyData?.isFromChartAuditReport)}
        providerUserId={chartAuditUserId}
      />
    ),
  };

  return (
    <Layout
      search={proceduresSearchTerm}
      status={proceduresStatus}
      loadMore={fetchNextProcedures}
    >
      {tabByType[activeTab] || tabByType[PROVIDER_ROOM_PROCEDURE_TYPE.cosmetic]}
    </Layout>
  );
}

function mapStateToProps(state) {
  return {
    activeTab: providerRoom.selectors.selectCurrentTab(state),
  };
}

export default connect(mapStateToProps)(TabSignedByMd);
